import { call, put, takeLatest } from "redux-saga/effects";
import {
  createOrgSuccess,
  createOrgFailure,
  orgUserListFail,
  orgUserListSuccess,
} from "../slices/org.slice";
import {
  createDepartmentApi,
  deleteDepartmentApi,
  editDepartmentApi,
  listDepartmentApi,
} from "../Api/api";
import { toast } from "react-toastify";
import {
  createDepartmentsFail,
  createDepartmentsLoad,
  createDepartmentsSuccess,
  departmentsDeleteLoad,
  departmentsEditLoad,
  departmentsListFail,
  departmentsListLoad,
  departmentsListSuccess,
} from "../slices/department.slice";

function* departmentCreateSaga(action) {
  try {
    const response = yield call(createDepartmentApi, action.payload.payload);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield call(action.payload.onSuccess);
      yield put(createDepartmentsSuccess());
    } else {
      toast.error(response?.result?.message);
      yield put(createDepartmentsFail());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(createDepartmentsFail());
  }
}

function* departmentListSaga(action) {
  try {
    const data = yield call(listDepartmentApi, action.payload);
    if (data.status === 0) {
      yield put(
        departmentsListSuccess({
          data: data.result.data,
          pagination: data.result.pagination,
        })
      );
    } else {
      yield put(departmentsListFail());
    }
  } catch {
    yield put(departmentsListFail());
  }
}

function* removeDepartmentSaga(action) {
  try {
    const response = yield call(deleteDepartmentApi, action.payload.id);
    if (response?.status == 0) {
      toast.success(response?.result?.message);
      yield call(action.payload.onSuccess);
      yield put(createOrgSuccess());
    } else {
      toast.error(response?.result?.message);
      yield put(createOrgFailure());
    }
  } catch (error) {
    toast.error("Some thing went wrong");
    yield put(createOrgFailure());
  }
}

function* departmentSaga() {
  yield takeLatest(createDepartmentsLoad.type, departmentCreateSaga);
  yield takeLatest(departmentsListLoad.type, departmentListSaga);
  yield takeLatest(departmentsDeleteLoad.type, removeDepartmentSaga);
}

export default departmentSaga;
